import * as React from 'react';
import { matchesSearch } from '../../common/utils/productListUtilsCoCo.js';
import { getLocalizedString } from '../../common/utils/productOfferingsUtils.js';
import { InputSearch } from '../InputSearch/InputSearch.js';
import { getDeviceBrand } from './productGridUtilsCoCo.js';
import type { DeviceProductOffer } from './productGridUtilsCoCo.js';

export const gridSearch = (searchString: string) => (offer: DeviceProductOffer) =>
  matchesSearch(searchString, [getLocalizedString(offer.name), getDeviceBrand(offer)]);

export interface ProductGridSearchCoCoProps {
  onChange: (newValue: string) => void;
  value: string;
  placeholder: string;
}

export const ProductGridSearchCoCo = ({ onChange, placeholder, value }: ProductGridSearchCoCoProps) => (
  <div className="of-product-grid-search">
    <InputSearch
      placeholder={placeholder}
      onChange={(e: React.SyntheticEvent<HTMLInputElement>) => onChange(e.currentTarget.value)}
      value={value}
      noSubmit={true}
    />
  </div>
);
